<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.note.dialog.duplicate-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">
		{{ 'mes.employee-notes.edit.title' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['newNote'].invalid && controls['newNote'].touched) {
				<mat-error>
					{{ 'mes.employee-notes.create.note.error.' + getFirstValidationErrorName('note') | translate }}
				</mat-error>
			}
			<mat-label class="mat-body-1">
				{{ 'mes.employee-notes.create.note.label' | translate }}
			</mat-label>
			<input maxlength="255" matInput formControlName="newNote" [appDisableWithoutPermission]="['mes:EmployeeNoteCreate']" />
		</mat-form-field>

		<ng-container formArrayName="notes">
			@for (noteControl of notesControlArray.controls; track noteControl; let i = $index) {
				<div class="note-form-row" [formGroup]="noteControl">
					<mat-form-field appearance="outline" class="dialog">
						@if (noteControl.invalid && noteControl.touched) {
							<mat-error>
								{{ 'mes.employee-notes.create.note.error.' + getFirstValidationErrorName('notes') | translate }}
							</mat-error>
						}
						<input maxlength="255" matInput formControlName="note" [appDisableWithoutPermission]="['mes:EmployeeNoteUpdate']" />
					</mat-form-field>
					<button type="button" mat-icon-button [attr.aria-label]="'mes.administration.shift-approval.table.timestamps-table.commands.add-timestamp' | translate" [appDisableWithoutPermission]="['mes:EmployeeNoteDelete']" (click)="onDelete(noteControl)">
						<mat-icon svgIcon="acies_delete"></mat-icon>
					</button>
				</div>
			}
		</ng-container>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">
			{{ 'general.ok' | translate }}
		</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
			{{ 'general.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</form>
